import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79e90b36")

_pushScopeId("data-v-79e90b36")
const _hoisted_1 = { class: "image__wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImageSpinner = _resolveComponent("ImageSpinner")
  const _directive_lazyload = _resolveDirective("lazyload")

  return _withDirectives((_openBlock(), _createBlock("figure", _hoisted_1, [
    _createVNode(_component_ImageSpinner, { class: "image__spinner" }),
    _createVNode("img", {
      class: ["image__item", _ctx.imageClass],
      "data-url": _ctx.source,
      alt: _ctx.alt,
      style: _ctx.imageStyle
    }, null, 14, ["data-url", "alt"])
  ], 512)), [
    [_directive_lazyload]
  ])
})